import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpBackend, HttpClient, HttpClientModule} from '@angular/common/http';
import { AJSCurrencyServiceProvider, commonsTranslateLoader, rootScopeProvider } from 'ib-web-commons/utils';
import { MmBAppConstants } from './ib-MmB-constants';
import { IbMenusAppModule } from 'ib-menus';
import { IbCPipeModule } from 'ib-web-commons/pipes';
import { IbCModalModule } from 'ib-web-commons/ib-modal';
import { IbCDirectivesModule } from 'ib-web-commons/directives';
import { DatalayerUtilsProvider, IbCDatalayerUtilsService } from 'ib-web-commons/ib-datalayer';
import { IbCommonGenericInterceptorProvider } from 'ib-web-commons/interceptor';
import { IbMmBAppRoutingModule } from './ib-MmB-app-routing.module';
import { AppComponent } from './app.component';
import { IbManageCarbonFootprintModule } from "./components/ib-MmB-booking-dashboard/components/ib-MmB-management-tab/components/ib-MmB-manage-carbonFootprint-info/ib-MmB-manage-carbonFootprint-info-module";
import { IbMmbFareFamilyConditionsModule } from '@src/components/ib-reusable-components/ib-mmb-fare-family-conditions/ib-mmb-fare-family-conditions.module';
import { AJSMmbModalServiceProvider } from '@src/components/ib-reusable-components/ib-MmB-modal/services/upgraded/ib-Mmb-modal-service-bridge.service';
import { IbFlexibilizationInfoVoucherDigitalModule } from "./components/ib-MmB-flexibilization/components/ib-flexibilization-info-voucher-digital/ib-flexibilization-info-voucher-digital.module";
import { SharedModule } from "./app/shared/shared.module";
import { ReactiveFormsModule } from "@angular/forms";
import { AJSMmBDatalayerUtilsServiceProvider } from './components/services/ib-MmB-datalayer/services/ib-MmB-datalayer-utils-service-bridge.service';
import { AJSCurrencyUtilsServiceProvider } from './components/services/Utils/ib-MmB-currency-utils-service-bridge.service';
import { IbMmmbGastronomicProposalModule } from './components/ib-MmB-gastronomic-proposal/ib-MmB-gastronomic-proposal.module';
import { WINDOW_TOKEN } from './ib-Mmb-app-tokens';
import { IbMmbPaymentModule } from './components/ib-MmB-payment/ib-MmB-payment.module';
import { NgReactModule } from './app/react/wrapper/ng-react.module';
import { CommonModule } from '@angular/common';
import { IbMmbConfirmationModule } from './components/ib-Mmb-confirmation/ib-mmb-confirmation.module';
import { AJSMmbUtilServiceProvider } from './components/services/Utils/ib-mmb-utils-bridge.service';
import { IbCashAviosInfoModule } from './components/ib-MmB-on-hold-confirmation/components/ib-cash-avios-info/ib-cash-avios-info.module';
import { IbAncillariesAppModule } from 'ib-web-ancillaries';

export function createTranslateLoader (http: HttpClient) {
    return commonsTranslateLoader(http, [
        MmBAppConstants.i18nRoute,
        MmBAppConstants.generalI18nRoute
    ]);
}

const commonsModules = [
    IbCPipeModule,
    IbCModalModule,
    IbCDirectivesModule
];
const downgradedMMBComponents = [
];

const upgradedMMBProviders = [
    AJSCurrencyServiceProvider,
    AJSMmbUtilServiceProvider
]

@NgModule({
    declarations: [
        AppComponent,
        ...downgradedMMBComponents
    ],
    imports: [
        CommonModule,
        BrowserModule,
        UpgradeModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'es'
        }),
        ...commonsModules,
        IbMmBAppRoutingModule,
        IbMenusAppModule,
        IbManageCarbonFootprintModule,
        IbMmbFareFamilyConditionsModule,
        IbFlexibilizationInfoVoucherDigitalModule,
        SharedModule,
        ReactiveFormsModule,
        IbMmmbGastronomicProposalModule,
        NgReactModule,
        IbMmbPaymentModule,
        IbMmbConfirmationModule,
        IbCashAviosInfoModule,
        IbAncillariesAppModule
    ],
    providers: [
        rootScopeProvider,
        DatalayerUtilsProvider,
        ...IbCommonGenericInterceptorProvider,
        IbCDatalayerUtilsService,
        AJSMmbModalServiceProvider,
        AJSMmBDatalayerUtilsServiceProvider,
        AJSCurrencyUtilsServiceProvider,
        { provide: WINDOW_TOKEN, useValue: window },
        ...upgradedMMBProviders
    ],
    bootstrap: [
        AppComponent
    ],
    exports: [
        NgReactModule
    ]
})
export class IbMmbAppModule {
    static components = [ ...downgradedMMBComponents];
}
